(function () {
  class SlShopByCategory extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.slider = this.querySelector('[data-sl-shop-slider]');
      this.mobileSlider = this.querySelector('[data-sl-shop-slider-mobile]');
      this.nextButton = this.querySelector('[data-sl-shop-next]');
      this.prevButton = this.querySelector('[data-sl-shop-prev]');
      this.progressFill = this.querySelector('[data-sl-shop-progress-fill]');
      this.boundUpdateProgress = this.updateProgress.bind(this);

      if (typeof window.Swiper === 'undefined') return;

      if (this.slider) {
        this.swiper = new window.Swiper(this.slider, {
          slidesPerView: 1.15,
          spaceBetween: 12,
          speed: 600,
          watchOverflow: true,
          navigation:
            this.nextButton && this.prevButton
              ? {
                  nextEl: this.nextButton,
                  prevEl: this.prevButton,
                }
              : false,
          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: 14,
            },
            1200: {
              slidesPerView: 6,
              spaceBetween: 14,
            },
          },
          on: {
            init: () => this.updateProgress(),
            resize: () => this.updateProgress(),
            setTranslate: () => this.updateProgress(),
            transitionEnd: () => this.updateProgress(),
          },
        });
      }

      if (this.mobileSlider) {
        this.mobileSwiper = new window.Swiper(this.mobileSlider, {
          slidesPerView: 1,
          spaceBetween: 12,
          speed: 600,
          watchOverflow: true,
          on: {
            init: () => this.updateProgress(),
            resize: () => this.updateProgress(),
            setTranslate: () => this.updateProgress(),
            transitionEnd: () => this.updateProgress(),
          },
        });
      }

      window.addEventListener('resize', this.boundUpdateProgress);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundUpdateProgress);
      this.swiper?.destroy?.(true, true);
      this.mobileSwiper?.destroy?.(true, true);
    }

    updateProgress() {
      const activeSwiper =
        window.matchMedia('(max-width: 767px)').matches ? this.mobileSwiper : this.swiper;

      const track = this.querySelector('.sl-shop-by-category__progress');
      if (!this.progressFill || !track || !activeSwiper) return;

      const snapCount = activeSwiper.snapGrid?.length || 0;
      if (snapCount <= 1) {
        this.progressFill.style.width = '100%';
        this.progressFill.style.transform = 'translateX(0px)';
        return;
      }

      const visibleRatio = Math.min(1, activeSwiper.width / activeSwiper.virtualSize);
      const trackWidth = track.clientWidth || 100;
      const thumbWidthPx = Math.max(24, visibleRatio * trackWidth);
      const minTranslate = activeSwiper.minTranslate ? activeSwiper.minTranslate() : 0;
      const maxTranslate = activeSwiper.maxTranslate ? activeSwiper.maxTranslate() : 0;
      const translateRange = minTranslate - maxTranslate;
      let progress = 0;

      if (translateRange > 0) {
        progress = (minTranslate - activeSwiper.translate) / translateRange;
      }

      progress = Math.min(1, Math.max(0, progress));
      const travelPx = Math.max(0, trackWidth - thumbWidthPx);

      this.progressFill.style.width = `${thumbWidthPx}px`;
      this.progressFill.style.transform = `translateX(${travelPx * progress}px)`;
    }
  }

  if (!customElements.get('sl-shop-by-category')) {
    customElements.define('sl-shop-by-category', SlShopByCategory);
  }
})();
